import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

function signInFailure(draft: Draft<IAuthData>) {
  draft.config.isLoading = false;
}

export default signInFailure;
